export { buildLegacyI18n } from './src/build-legacy-i18n';
export { mergeLegacyI18ns } from './src/merge-legacy-i18n';
